import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props, union } from "@ngrx/store";

export const errorOccurred = createAction(
  "[FRH] Error Occurred",
  props<{ error: HttpErrorResponse }>()
);

export const doNothing = createAction("[FRH] Do Nothing");

const all = union({
  errorOccurred,
  doNothing,
});

export type SharedActionsUnion = typeof all;
